import Store from 'store';

/**
 * Custom implementation of store, extending the setter with "session" option
 * A session is a key on which all of the values kept under
 * Then we can call clearAll(<session name>) to clear any values related to
 * that session.
 *
 * I.e. we want to clear all user-related data when the user logged out.
 * We can set the storage, supplying with a session called "login"
 * And then on logout, we can call clearAll("login") to remove them.
 */

const INTERNAL_SESSION_STORAGE_KEY = 'session:';

interface StorageOption {
  readonly session?: string;
}

const storage = {
  get: Store.get.bind(Store),
  each: Store.each.bind(Store),
  remove: Store.remove.bind(Store),
  clearAll(session?: string) {
    if (session) {
      const key = `${INTERNAL_SESSION_STORAGE_KEY}${session}`;
      const _session: string[] = Store.get(key) || [];

      _session.forEach((_key) => {
        Store.remove(_key);
      });

      return Store.remove(key);
    }

    return Store.clearAll();
  },
  set<T>(key: string, value: T, option?: StorageOption) {
    if (option?.session) {
      // Register the key as part of a session.
      const _key = `${INTERNAL_SESSION_STORAGE_KEY}${option.session}`;
      const session: string[] = Store.get(_key) || [];

      session.push(key);

      Store.set(_key, session);
    }

    return Store.set(key, value);
  },
};

export { storage, INTERNAL_SESSION_STORAGE_KEY as _INTERNAL_SESSION_STORAGE_KEY };
